import { Component, Vue } from "vue-property-decorator";
import { DateTime } from "luxon";
import { ParameterActivationEnum } from "../constants/parameter_activation_enum.constants";

/*
 * Common utilitary methods like date formatting, delays...
 */
@Component
class UtilityMixin extends Vue {
  /*
   * change favicon dynamically when not on odonatech domain name
   * (for diversico domain for example)
   */
  public changeFaviconAndTitle(href, title) {
    var link: any = document.querySelector("link[rel~='icon']");
    if (!link) {
      link = document.createElement("link");
      link.rel = "icon";
      document.getElementsByTagName("head")[0].appendChild(link);
    }
    link.href = href;
    document.title = title;
  }

  public get isMobile() {
    var isMobile = window.screen.width < 576;
    return isMobile;
  }

  public vowelTest(s) {
    return /^[aeiou]$/i.test(s);
  }

  /*
   * Force loading cursor on whole page by adding waiting id
   */
  public loadingCursor(loading) {
    if (loading) {
      document.body.id = "waiting";
    } else {
      document.body.id = null;
    }
  }

  /*
   * date of O2S features deployment, some code is different before this date
   */
  public get o2sStartDate() {
    return new Date(this.$store.getters.o2sStartDate);
  }

  public getNonReglementaireParam(listParam){
    return listParam.filter(
      (obj) => obj.parameter.name === ParameterActivationEnum.NON_REGLEMENTAIRE_ACTIVATION && obj.value == "true"
    )[0];
  }

  public get isDetailedFacettes() {
    let listParametersActivated = this.$store.getters.listParametersActivated;
    let filteredList = listParametersActivated.filter(
      (obj) => obj.parameter.name === ParameterActivationEnum.DETAILED_FACETTES_ACTIVATION && obj.value === "true"
    );
    return filteredList.length > 0;
  }

  public getDetailedFacettesParam(listParam){
    return listParam.filter(
      (obj) => obj.parameter.name === ParameterActivationEnum.DETAILED_FACETTES_ACTIVATION && obj.value == "true"
    )[0];
  }

  scrollToTop(dest, behavior) {
    if (!behavior) behavior = "instant";
    if (!dest) dest = "app-top";
    const target = document.getElementById(dest);

    if (target.getBoundingClientRect().top > 0 && dest !== "top-boost") return;
    target.scrollIntoView({ block: "start", behavior: behavior });
  }

  formatDate(date) {
    const lang = this.$store.getters.currentLanguage;
    return DateTime.fromISO(date).setLocale(lang).toFormat("dd/MM/yy à T");
  }

  formatDateSmall(date) {
    const lang = this.$store.getters.currentLanguage;
    const dateFormatted = DateTime.fromISO(date).setLocale(lang).toFormat("dd/MM/yy");
    const timeFormatted = DateTime.fromISO(date).setLocale(lang).toLocaleString(DateTime.TIME_SIMPLE);
    if (dateFormatted.indexOf("Invalid") > -1) return;
    else return dateFormatted + " à " + timeFormatted;
  }

  formatDateMini(date) {
    const lang = this.$store.getters.currentLanguage;
    const dateFormatted = DateTime.fromISO(date).setLocale(lang).toFormat("dd/MM/yy");
    if (dateFormatted.indexOf("Invalid") > -1) return;
    else return dateFormatted;
  }

  formatSnakeToCamelCase(string) {
    return string
      .toLowerCase()
      .replace(/([-_][a-z])/g, (group) => group.toUpperCase().replace("-", "").replace("_", ""));
  }

  public checkNoNull(obj) {
    let values = Object.values(obj);
    for (let i in values) {
      if (values[i] == null) return false;
    }
    return true;
  }

  public removeDuplicates(arr) {
    // remove duplicates in array
    let ids = arr.map((o) => o.id);
    return arr.filter(({ id }, index) => !ids.includes(id, index + 1));
  }

  /*
   * use a promise instead of a settimeout for delays
   */
  public wait(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  public getRandomInt(max) {
    return Math.floor(Math.random() * max);
  }

  /*
   * transform base64 to downloadable file on browser
   */
  public base64ToArrayBuffer(base64) {
    var binaryString = window.atob(base64);
    var binaryLen = binaryString.length;
    var bytes = new Uint8Array(binaryLen);
    for (var i = 0; i < binaryLen; i++) {
      var ascii = binaryString.charCodeAt(i);
      bytes[i] = ascii;
    }
    return bytes;
  }

  downloadFile(filePath, name) {
    var link = document.createElement("a");
    link.href = filePath;
    link.download = name;
    link.click();
  }

  public get isCALanguage(){
    let currentLanguage = this.$store.getters.currentLanguage;
    if(currentLanguage.includes("CA"))return true;
    else return false;
  }

  public get onDiversico() {
    const navClient = this.$store.getters.navClient;
    let currentLanguage = this.$store.getters.currentLanguage;
    if (!navClient) return false;
    if (!navClient.offer) return false;
    return navClient.offer.indexOf("DIVERSICO") > -1;
  }

  public get onCALanguage(){
    let currentLanguage = this.$store.getters.currentLanguage;
    if(currentLanguage.includes('CA'))return true
    else return false
  }

  public get onGDP() {
    let listParametersActivated = this.$store.getters.listParametersActivated;
    if (!listParametersActivated || listParametersActivated == undefined) return false;
    let detailedFacette = this.getDetailedFacettesParam(listParametersActivated);
    if (detailedFacette)return true;
    else return false
  }

  get checkBrowser() {
    var isChromium: any = (window as any).chrome;
    var winNav = window.navigator;
    var vendorName = winNav.vendor;
    var isOpera = typeof (window as any).opr !== "undefined";
    var isIEedge = winNav.userAgent.indexOf("Edg") > -1;
    var isIOSChrome = winNav.userAgent.match("CriOS");

    let browser = "";

    if (isIOSChrome) {
      // is Google Chrome on IOS
      browser = "ChromeIOS";
    } else if (
      isChromium !== null &&
      typeof isChromium !== "undefined" &&
      vendorName === "Google Inc." &&
      isOpera === false &&
      isIEedge === false
    ) {
      // is Google Chrome
      browser = "Chrome";
    } else {
      browser = "Other";
    }
    return browser;
  }
}
export default UtilityMixin;
